import { render } from "./agentinfo.vue?vue&type=template&id=720a0bc2"
import script from "./agentinfo.vue?vue&type=script&lang=js"
export * from "./agentinfo.vue?vue&type=script&lang=js"

import "./agentinfo.vue?vue&type=style&index=0&id=720a0bc2&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__